/**
 * Created by lihanying on 2017/7/24.
 */
import React from 'react'
import { CloseOutlined, UploadOutlined } from '@ant-design/icons'
import {
  Modal,
  Switch,
  Input,
  Select,
  Upload,
  Button,
  message,
  Checkbox,
  Row,
  Col,
  Spin,
} from 'antd'
import './style.css'
import { IMAGE_DOMAIN } from '../../../config'
import { validateImageFile } from '../../../util'
import { CLUB_ID } from '../../ClubBusiness/constants'

const Option = Select.Option

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      disabled: false,
      searchValue: '',
      commodity_name: '',
      commodity_price: '',
      unit: '',
      type_id: this.props.commodityType ? this.props.commodityType[0].id : 0,
      order_num: '0',
      off_shelve: '0',
      non_standard: '0',
      total_id: this.props.commodityTotal.firmList.map((item) => item.id),
      type_name: '',
      materials: '0',
      warning: '',
      cost_income: '0',
      qty_income: '0',
      re_price: '',
      al_price: '',
    }
  }

  onUpload = (e) => {
    let file = e.target.files[0]
    if (!validateImageFile(file)) {
      e.target.value = ''
      return
    }
    this.setState({ loading: true })
    let token = this.props.qiniuToken.token
    let form = new FormData()
    form.append('token', token)
    form.append('file', file)
    if (token != '') {
      this.props.fetchQiniu(form).then((res) => {
        this.setState({ loading: false })
      })
    } else {
      this.setState({ loading: false })
      message.error('上传失败')
    }
  }

  onChange1 = (value) => {
    let off_shelve = 0
    if (value) {
      off_shelve = 1
    }
    this.setState({ off_shelve: off_shelve })
  }
  onChange2 = (value) => {
    let non_standard = 0
    if (value) {
      non_standard = 1
    }
    this.setState({ non_standard: non_standard })
  }

  onChange = (value) => {
    let materials = '0'
    let disabled = false
    if (value) {
      //原材料
      materials = '1'
      disabled = true
      this.setState({
        commodity_price: '',
        order_num: '0',
        warning: '',
      })
    }
    this.setState({ materials: materials, disabled: disabled })
  }

  handleSelect = (value) => {
    const { commodityType } = this.props
    if (!commodityType) {
      return
    }
    let obj = commodityType.filter((item) => item.id === value)[0] || {}
    let disabled = false,
      materials = '0'
    if (obj.materials === '1') {
      //原材料
      disabled = true
      materials = '1'
      this.setState({
        //清除要禁止的值
        commodity_price: '',
        order_num: '0',
        warning: '',
      })
    }
    this.setState({ type_id: value, disabled: disabled, materials: materials })
  }
  render() {
    const { modalAdd, commodityType, imageUrl, commodityTotal } = this.props
    const { disabled } = this.state

    let imgUrl
    if (imageUrl.url) {
      imgUrl = IMAGE_DOMAIN + imageUrl.url
    } else {
      imgUrl = ''
    }

    return (
      <div>
        <Modal
          title="添加商品"
          visible={modalAdd}
          onOk={() =>
            this.props.handleOk({
              club_id: sessionStorage.getItem(CLUB_ID),
              name: this.state.commodity_name,
              price: this.state.commodity_price,
              unit: this.state.unit,
              type_id: this.state.type_id,
              pic: imageUrl.url || '',
              ordernum: this.state.order_num,
              off_shelve: this.state.off_shelve,
              non_standard: this.state.non_standard,
              firm_ids: this.state.total_id,
              type_name: this.state.type_name,
              materials: this.state.materials,
              warning: this.state.warning,
              cost_income: this.state.cost_income * 100,
              qty_income: this.state.qty_income,
              al_price: this.state.al_price,
              re_price: this.state.re_price,
            })
          }
          onCancel={this.props.handleCancel}
          width="1000px"
        >
          <div className="commodity">
            <div className="commodity-left">
              <div className="commodity-item">
                <span className="diamond-span">商品名称:</span>
                <Input
                  style={{ width: '80%', marginLeft: '1rem' }}
                  placeholder="请输入商品名称"
                  onChange={(e) =>
                    this.setState({ commodity_name: e.target.value })
                  }
                />
              </div>
              <div className="commodity-item">
                <span className="diamond-span">商品分类:</span>
                <Select
                  defaultValue={commodityType ? commodityType[0].id : 0}
                  style={{ width: '80%', marginLeft: '1rem' }}
                  onChange={(value) => this.handleSelect(value)}
                >
                  {commodityType &&
                    commodityType.map((item, idx) => {
                      return (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      )
                    })}
                  <Option key="-1" value="-1">
                    自定义
                  </Option>
                </Select>
              </div>
              {this.state.type_id === '-1' ? (
                <div>
                  <div className="commodity-item">
                    <span className="diamond-span">分类名称:</span>
                    <Input
                      style={{ width: '80%', marginLeft: '1rem' }}
                      placeholder="请输入新分类名称"
                      onChange={(e) =>
                        this.setState({ type_name: e.target.value })
                      }
                    />
                  </div>
                  <div className="commodity-item">
                    <span>是否为原材料:</span>
                    <Switch
                      onChange={this.onChange}
                      style={{ marginLeft: '1rem' }}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
              <div className="commodity-item">
                <span className="diamond-span">销售价格:</span>
                <Input
                  style={{ width: '80%', marginLeft: '1rem' }}
                  disabled={disabled}
                  placeholder="请输入商品销售价格"
                  onChange={(e) =>
                    this.setState({ commodity_price: e.target.value })
                  }
                />
              </div>
              <div className="commodity-item">
                <span className="diamond-span">钻石抵扣:</span>
                <Input
                  addonAfter="元"
                  style={{ width: '35%', marginLeft: '1rem' }}
                  disabled={disabled}
                  placeholder="销售价格"
                  onChange={(e) => this.setState({ re_price: e.target.value })}
                />
                <span className="commodity-diamond">+</span>
                <Input
                  addonAfter="钻"
                  style={{ width: '35%' }}
                  disabled={disabled}
                  placeholder="钻石数量(只接受整数)"
                  onChange={(e) => this.setState({ al_price: e.target.value })}
                />
              </div>
              <div className="commodity-item">
                <span className="diamond-span">单位:</span>
                <Input
                  style={{ width: '80%', marginLeft: '2.4rem' }}
                  placeholder="商品的单位"
                  onChange={(e) => this.setState({ unit: e.target.value })}
                />
              </div>
              <div className="commodity-item">
                <span className="diamond-span">菜单排序:</span>
                <Input
                  style={{ width: '80%', marginLeft: '1rem' }}
                  disabled={disabled}
                  placeholder="数字越小,排列越前,可不填"
                  onChange={(e) => this.setState({ order_num: e.target.value })}
                />
              </div>
              <h3>库存设置</h3>
              <div className="commodity-item">
                <span className="diamond-span">库存报警数量:</span>
                <Input
                  style={{ width: '73%', marginLeft: '1rem' }}
                  disabled={disabled}
                  placeholder="库存低于该数就会提醒入货"
                  onChange={(e) => this.setState({ warning: e.target.value })}
                />
              </div>
              <div className="commodity-item">
                <span className="diamond-span">本次入库数量:</span>
                <Input
                  style={{ width: '73%', marginLeft: '1rem' }}
                  placeholder="请输入入库数量,不填即默认库存为零"
                  onChange={(e) =>
                    this.setState({ qty_income: e.target.value })
                  }
                />
              </div>
              <div className="commodity-item">
                <span className="diamond-span">本次进货单价:</span>
                <Input
                  style={{ width: '73%', marginLeft: '1rem' }}
                  placeholder="请输入商品的单价,不填即默认为零"
                  onChange={(e) =>
                    this.setState({ cost_income: e.target.value })
                  }
                />
              </div>
              <div style={{ marginBottom: '2rem' }}>
                <div>商品销售区域:</div>
                <Checkbox.Group
                  value={this.state.total_id}
                  style={{ width: '100%' }}
                  onChange={(value) => this.setState({ total_id: value })}
                >
                  <Row>
                    {commodityTotal &&
                      commodityTotal.firmList &&
                      commodityTotal.firmList.map((item, idx) => {
                        return (
                          <Col span={6} key={idx}>
                            <Checkbox value={item.id}>
                              {item.type_name}
                            </Checkbox>
                          </Col>
                        )
                      })}
                  </Row>
                </Checkbox.Group>
              </div>
              <div>
                <span>是否为加工制品:</span>
                <Switch
                  defaultChecked={false}
                  disabled={disabled}
                  onChange={this.onChange2}
                  style={{ marginLeft: '.2rem' }}
                />
              </div>
              <p className="diamond-item">
                (注: 加工制品如 快餐, 调饮等商品, 该类商品不设库存,
                日常无需入库)
              </p>
              <div className="diamond-item">
                <span>下架:</span>
                <Switch
                  defaultChecked={false}
                  disabled={disabled}
                  onChange={this.onChange1}
                  style={{ marginLeft: '2.5rem' }}
                />
              </div>
            </div>
            <div className="commodity-right">
              <Button type="primary" style={{ marginBottom: '1rem' }}>
                <UploadOutlined />
                <input
                  type="file"
                  className="upload-input"
                  onChange={(e) => this.onUpload(e)}
                />
                上传图片
              </Button>
              {this.state.loading ? (
                <Spin
                  tip="正在加载..."
                  className="level-loading"
                  style={{ textAlign: 'center' }}
                />
              ) : (
                <div>
                  {imgUrl && (
                    <div className="commodity-image">
                      <div>
                        <img
                          src={imgUrl}
                          alt=""
                          style={{ width: '100px', height: '100px' }}
                        />
                        <CloseOutlined
                          className="commodity-icon"
                          onClick={() => this.props.getImageUrl({})}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/component/modalAdd.js